import { store } from "@3gaam/capp/src/store";
import {
  goOfflineAction,
  setShowOnlineStatusPopup,
} from "@3gaam/capp/src/store/consultee";
import { useAppSelector } from "@3gaam/capp/src/store/hooks";
import Logo from "@3gaam/shared/assets/images/3gaam-logo-light.svg";
import Icon from "@3gaam/shared/components/general/icon";
import Image from "@3gaam/shared/components/general/image";
import React, { useCallback, useState } from "react";
import ToggleSwitch from "../general/form/toggleSwitch";
import Drawer from "./drawer";

function toggleSwitchHandler() {
  const onlineStatus = store.getState().consultee.applicant?.OnlineStatus;
  const skipOfflineConfirm =
    store.getState().consultee.onlineStatusPopup.skipOfflineConfirm;
  if (onlineStatus && skipOfflineConfirm) {
    store.dispatch(goOfflineAction({}));
  } else {
    store.dispatch(setShowOnlineStatusPopup(true));
  }
}

const Header = ({}) => {
  const [showDrawer, setShowDrawer] = useState(false);
  const onlineStatus = useAppSelector(
    (state) => state.consultee?.applicant?.OnlineStatus,
  );
  const handleShowDrawer = useCallback(() => {
    setShowDrawer((showDrawer) => !showDrawer);
  }, []);

  return (
    <>
      <header className="position-relative header-height bg-primary d-flex flex-row align-items-center justify-content-between text-center ">
        <div
          className="position-absolute d-flex align-items-center justify-content-center"
          style={{
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            margin: "auto",
            zIndex: 1,
          }}
        >
          <Image src={Logo} style={{ width: 82 }} alt="۳گام" />
        </div>
        <div
          onClick={handleShowDrawer}
          className="open-drawer d-flex font-28 cur-pointer mr-3 text-white"
          style={{ position: "relative", zIndex: 2 }}
        >
          <Icon name="FA_R-bars" />
        </div>

        <div
          className="ml-3 h-100 d-flex align-items-center"
          style={{ position: "relative", zIndex: 2 }}
        >
          <ToggleSwitch checked={onlineStatus} onClick={toggleSwitchHandler} />
        </div>
      </header>
      <Drawer showDrawer={showDrawer} setShowDrawer={setShowDrawer} />
    </>
  );
};

export default React.memo(Header);
